import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { appAxios } from '@doda/common/src/libs/axios/appAxios';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { RootState } from '@doda/pc/src/redux/store';
import { recommendModalSelector } from '../index';
import { RecommendModal } from './recommendModal';

/**
 * リクエストパラメータ
 */
export interface RequestArg {
  wjoid: number;
  wknnrfl: 0 | 1;
  wkmnsfl: 0 | 1;
}

/**
 * 志向性蓄積テーブル登録API 実行
 */
export const postRecommendModal = createAsyncThunk<
  RecommendModal,
  RequestArg,
  { rejectValue: Record<string, never> }
>(
  'intentMatchModal/recommendModal',
  ({ wjoid, wknnrfl, wkmnsfl }, thunkAPI) => {
    const data = new URLSearchParams();
    data.append('wjoid', wjoid.toString());
    data.append('wknnrfl', wknnrfl.toString());
    data.append('wkmnsfl', wkmnsfl.toString());
    return appAxios({
      url: '/dcfront/recommend/ajax/recommendModalAjax/',
      method: 'post',
      data,
    })
      .then((response: AxiosResponse<RecommendModal>) => {
        return response.data;
      })
      .catch(() => {
        return thunkAPI.rejectWithValue({});
      });
  },
  {
    condition: (_, { getState }) => {
      const { loading } = recommendModalSelector(getState() as RootState);
      return loading !== LOADING_STATUS.PENDING;
    },
  }
);
